<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.Cash.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.Cash.msg2') }}</div>
        <div class="lyr-txt">{{ $t('Modal.Cash.msg3') }}</div>
      </div>
      <div class="layer__body">
        <div class="flex-row">
          <div class="lyr-left img-info">
            <img v-if="inputAmount < totalUprc" src="@/assets/images/user/artwork_popup_cash_in_3d_jp.gif" alt="" class="img-size" />
            <img v-if="inputAmount >= totalUprc" src="@/assets/images/user/artwork_popup_cash_out_3d_jp.gif" alt="" class="img-size" />
          </div>
          <div class="lyr-right">
            <div class="lst-order--cash">
              <dl>
                <dt>{{ $t('Modal.Cash.msg4') }}</dt>
                <dd>{{ $displayUprc(totalUprc) }}</dd>
              </dl>
              <dl>
                <dt>{{ $t('Modal.Cash.msg5') }}</dt>
                <dd>{{ $displayUprc(inputAmount) }}</dd>
              </dl>
              <dl class="change">
                <dt>{{ $t('Modal.Cash.msg6') }}</dt>
                <dd class="">
                  {{ inputAmount > totalUprc ? $displayUprc(inputAmount - totalUprc) : 0 }}
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="layer__button">
        <button
          class="btn btn--cancel btn--xlg btn-anim"
          style="width:100%; !important"
          @mouseup="cancelPayment()"
          :disabled="inputAmount >= totalUprc || cancelYn"
          :class="{'btn--disabled': inputAmount >= totalUprc}"
        >
          {{ $t('Modal.Cash.msg7') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cash',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      currUnitText: this.$store.getters.getCurrUnitText,
      inputAmount: 0,
      baskets: this.$store.getters.getBaskets,
      cancelYn: false,
      oneCallYn: false,
      tranUrl: '',
      text: '',
    };
  },
  mounted() {
    this.paymentEnd();
  },
  props: {
    totalUprc: Number,
    tran: Object,
  },
  methods: {
    paymentEnd() {
      let tranObj = {
        tranNo: this.tran.tranNo,
        orderNo: this.tran.orderNo,
        payType: 'CASH',
        totalUprc: this.totalUprc,
      };
      this.$emit('setPayComplete', tranObj);
    },
    async cancelPayment() {
      this.cancelYn = false;
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    inputAmount(amt) {},
  },
  components: {},
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style scoped>
.lst-order--cash {
  width: 100%;
  margin-top: 2em;
}
</style>
